import React, { Fragment } from 'react'

import NoActivitiesMan from 'app/components/SVGS/NoActivitiesMan'
import ActivityLoader from 'app/domains/common/Loaders/ActivityLoader'
import Activity from 'app/domains/common/Activity'
import image from 'app/assets/images/great-job.png'

import './styles.scss'

const bs = 'different-activities-list'

const DifferentActivitiesList = ({
  t,
  activities,
  pending,
  loaded,
  tryDifferentActivity,
  img,
  acitivitiesManText,
  isFavorite,
}) =>
  pending && !loaded ? (
    <ActivityLoader />
  ) : activities.size ? (
    <div className={bs}>
      {activities.map((activity, i) => (
        <Activity
          key={i}
          activity={activity}
          onClick={() => tryDifferentActivity(activity.get('activityId'))}
          submitting={pending}
        />
      ))}
    </div>
  ) : (
    <div className={`${bs} ${bs}--no-activities`}>
      <NoActivitiesMan topText={t(acitivitiesManText)} />
      {isFavorite && (
        <Fragment>
          <p className={`${bs}--no-activities__hint`}>{t('Click on the heart button to add activity to favorites')}</p>
          <img src={image} />
        </Fragment>
      )}
    </div>
  )

export default DifferentActivitiesList
